import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { utils as commonUtils } from '@finley-technologies/common';

export const initSentry = () =>
  Sentry.init({
    environment: commonUtils.EnvUtils.getEnv(),
    dsn:
      'https://6a28f45305234366a8ed79c601b3f9c7@o686378.ingest.sentry.io/5784832',
    release: PACKAGE_VERSION,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // Sentry recommends adjusting this value in production
    tracesSampleRate: commonUtils.EnvUtils.isProduction() ? 0.9 : 1.0,
    integrations: [new Integrations.BrowserTracing()],
    beforeBreadcrumb(breadcrumb) {
      const updatedBreadcrumb = { ...breadcrumb };
      // null out the XHR log for s3 requests
      if (
        updatedBreadcrumb.category === 'xhr' &&
        updatedBreadcrumb.data &&
        updatedBreadcrumb.data.url.includes('amazonaws.com')
      ) {
        updatedBreadcrumb.data.url = '[FILTERED AWS REQUEST]';
      }
      return breadcrumb;
    },
    beforeSend(event) {
      // filter out errors caused by known crawlers
      if (/bytespider/i.test(window.navigator.userAgent)) return null;
      return event;
    },
  });
